/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 8/10/15.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageLiveClipViewController',
    function (
        _,
        $document,
        $filter,
        $interval,
        $location,
        $q,
        $routeParams,
        $scope,
        $window,
        durationFromSecFilter,
        secFromTimecodeFilter,
        timecodeFromSecFilter,
        twoDigitNumFilter,
        ContentResourceFactory,
        DownloadAssetService,
        DynamicPropertiesService,
        EndPointService,
        LiveClipResourceFactory,
        ModalService,
        NotificationService,
        PackageActionService,
        PackageLiveClipViewService,
        PackageMediaService,
        PackageResourceFactory,
        PackageUtilService,
        PartnerPackagesService,
        PermissionsService,
        UtilsService
    ) {

        let liveClippingMediaUrl = EndPointService.liveClippingMediaUrl;
        let webProxyMp4Url = EndPointService.webProxyMp4Url;
        let proxyUrl = EndPointService.proxyUrl;

        var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
        var ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE = 'ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';

        var self = this, defaultMediaPath = liveClippingMediaUrl,
            sidebarWidth = 235, editContainerPadding = 30, playerContainerPercent = 0.5, playerContainerPadding = 40;

        var windowElement = angular.element($window);
        var clipPlaying = null;
        var resumePlaybackAfterScheduleChange = false;
        var clipToEdit;
        var confirmingFeedSwitch = false;
        var createThumbnailAfterScheduleChange = false;

        self.loading = false;

        PackageLiveClipViewService.packageObject = self.packageObject;
        self.packageContent = null;
        self.updateFeedLabel = false;
        self.clipInEdit = null;
        self.clips = [];
        self.draftClips = [];
        self.feedScheduleMap = {};
        self.partnerPackages = [];

        self.totalDuration = PackageLiveClipViewService.totalDuration;

        self.activeEditTabs = {
            metadata: false,
            distribution: false,
            advanced: false,
            roles: false,
            prepostRolls: false
        };

        self.currentPlayheadTime = null;

        self.draftClipMode = false;
        self.vodMode = false;

        self.showClipsLoading = false;
        self.clipSearch = {includeDelivered: true};

        self.selectedClipArray = [];
        self.selectedDraftClipArray = [];

        self.selectAllFlag = false;

        var calcPlayerWidth = function () {
            var windowWidth = $window.innerWidth;
            var containerWidth = windowWidth - sidebarWidth - editContainerPadding;
            return containerWidth * playerContainerPercent - playerContainerPadding;
        };

        self.props = {
            width: calcPlayerWidth(),
            markIn: null,
            markOut: null,
            crossOrigin: 'anonymous',
            tracks: [],
            enableNLEHotKeys: true,
            maxPlaybackRate: 6
        };

        var calculateDuration = function () {
            var duration = (new Date(PackageLiveClipViewService.currentSchedule.stopTime).getTime() - new Date(PackageLiveClipViewService.currentSchedule.startTime).getTime()) / 60000;
            var extendBefore = parseInt(self.packageObject.content.extendBefore) || 0;
            var extendAfter = parseInt(self.packageObject.content.extendAfter) || 0;
            return (duration + extendBefore + extendAfter) * 60;
        };

        var resetActive = function () {
            self.activeEditTabs.metadata = self.activeEditTabs.distribution = self.activeEditTabs.advanced = self.activeEditTabs.roles = self.activeEditTabs.prepostRolls = false;
        };

        var setLoading = function (isLoading) {
            $scope.$emit('server-busy', {working: isLoading});
            self.loading = isLoading;
        };

        var getEditClipData = function (clip) {
            setLoading(true);
            return PackageLiveClipViewService.getEditClipData(clip).then(function () {
                self.clipInEdit = PackageLiveClipViewService.viewModel.clipInEdit;
                if (self.clipInEdit.clipStartOffset > -1 && self.clipInEdit.clipEndOffset > -1) {
                    self.props.markIn = self.clipInEdit.clipStartOffset;
                    self.props.markOut = self.clipInEdit.clipEndOffset;
                }
                self.props.editMode = true;
                resetActive();
                self.activeEditTabs.metadata = true;
                if (clipToEdit) {
                    clipToEdit = null;
                } else if (!self.draftClipMode) {
                    $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
                } else {
                    $window.liveClippingVideoPlayer.pause();
                }
                self.partnerPackages = PartnerPackagesService.partnerPackages();
                setLoading(false);
            });
        };

        /**
         * This is a hack for now to programattically click the thumbnail button until the player has exposed an API for
         * us to generate a temporary thumbnail based on a timecode.
         */
        var generateNewThumbnail = function () {
            $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipImageOffset);
            $interval(function () {
                var evt = new Event('click', {'view': window, 'bubbles': true, 'cancelable': true});
                document.getElementById('thumbnailBtn').dispatchEvent(evt);
                createThumbnailAfterScheduleChange = false;
                setLoading(false);
                $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
            }, 1000, 1);
        };

        var handleStreamStatusEvent = function (e) {
            self.streamExists = e.originalEvent.detail.exists;
            if (self.streamExists) {
                windowElement.off('streamStatus');
                // Calling play then pause will cause the player to properly initialize so that seeking to clips works
                $window.liveClippingVideoPlayer.play();
                if (!self.currentFeed.isLive) {
                    // Keep pre-recorded clips from auto-playing if
                    // no stream was previously loaded in the player
                    $window.liveClippingVideoPlayer.seek(0.0);
                }
                $window.liveClippingVideoPlayer.pause();

                var now = new Date();
                var recordStart = new Date(self.record.startTime);
                var recordEnd = new Date(self.record.stopTime);
                if (now.getTime() >= recordStart.getTime() && now.getTime() <= recordEnd.getTime()) {
                    NotificationService.createInfoNotification('Live Event started for current Package!');
                }

                if (clipToEdit) {
                    setLoading(false);
                    getEditClipData(clipToEdit);
                } else if (self.clipInEdit.clipStartOffset && !createThumbnailAfterScheduleChange) {
                    setLoading(false);
                    $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
                } else if (createThumbnailAfterScheduleChange) {
                    //This is needed so the player actually has loaded the video, otherwise a thumbnail will be generated
                    // based on the first frame
                    $interval(generateNewThumbnail, 5000, 1);
                }

                if (resumePlaybackAfterScheduleChange) {
                    $window.liveClippingVideoPlayer.play();
                }
            }
        };

        var setPlayerPropsFromPrimaryVideo = function () {
            var videoPath = PackageLiveClipViewService.switchToPrimaryVideoFeed();
            var textTracks = PackageLiveClipViewService.setAvailableTextTracks();
            return $q.all({path: videoPath, tracks: textTracks}).then(function (videoData) {
                self.streamExists = true;
                self.props.markIn = null;
                self.props.markOut = null;
                self.props.mimeType = 'video/mp4';
                self.props.sourcePath = webProxyMp4Url + '/' + videoData.path;
                self.props.editMode = false;
                self.props.framerate = parseFloat(self.currentFeed.framerate);
                self.props.tracks = videoData.tracks;
                self.props.dropFrame = false;
                if (clipToEdit) {
                    setLoading(false);
                    getEditClipData(clipToEdit);
                }
                return videoData.path;
            });
        };

        var createLiveClip = function (clipData) {
            setLoading(true);
            clipData.name = PackageLiveClipViewService.createInitialLiveClipName();
            PackageLiveClipViewService.createNewClip(clipData).then(function () {
                setLoading(false);
                NotificationService.createSuccessNotification('Clip was succesfully saved.', 2000);
            });
        };

        var updateClip = function () {
            setLoading(true);
            PackageLiveClipViewService.onSave().then(function () {
                self.exitEditClipMode();
                NotificationService.createSuccessNotification('Clip was succesfully updated.', 2000);
                self.editorForm.$setPristine();
                setLoading(false);
            });
        };

        var handleUpdateForDeliveredClip = function (clip) {
            function confirmResetHandler() {
                setLoading(true);
                $q.all({
                    savePromise: PackageLiveClipViewService.onSave().$promise,
                    resetPromise: PackageLiveClipViewService.resetClip().$promise
                }).then(function () {
                    self.exitEditClipMode();
                    NotificationService.createSuccessNotification('Clip was succesfully updated and reset.', 2000);
                    self.editorForm.$setPristine();
                    setLoading(false);
                });
            }

            function cancelHandler() {
                self.props.markIn = self.clipInEdit.clipStartOffset;
                self.props.markOut = self.clipInEdit.clipEndOffset;
                self.props.editMode = true;
            }

            if (PackageLiveClipViewService.requiresResetAfterSave() && self.streamExists) {
                ModalService.showMessageModal({
                    messageText: 'Are you sure you want to update a delivered clip\'s mark points?\n' +
                    'Clip media will be recaptured and the clip\'s status reset to DRAFT.',
                    title: 'Confirm Clip Reset',
                    windowClass: 'confirm-modal-sm',
                    showOK: true,
                    pullCancelLeft: true
                }, confirmResetHandler, cancelHandler);
            } else {
                self.onSave();
            }
        };

        var getClipList = function () {
            return self.draftClipMode ? self.draftClips : self.clips;
        };

        var getSelectionArray = function () {
            return self.draftClipMode ? self.selectedDraftClipArray : self.selectedClipArray;
        };

        var clipSelectionChanged = function () {
            PackageActionService.selectedPackages = angular.copy(getSelectionArray());
            PackageActionService.handleEditView('clip');
        };

        var selectClipInEdit = function (clip) {
            getSelectionArray().splice(0, getSelectionArray().length);
            getSelectionArray().push(clip);
            self.selectAllFlag = false;
            clipSelectionChanged();
        };

        var getSelectionIndex = function (clip) {
            for (var idx = 0; idx < getSelectionArray().length; idx++) {
                if (clip.id === getSelectionArray()[idx].id) {
                    return idx;
                }
            }
            return -1;
        };

        var updateSelectionArray = function (viewModel) {
            var clipList = self.draftClipMode ? viewModel.draftClips : viewModel.clips;
            var newClipsMap = {};
            angular.forEach(clipList, function (clip) {
                newClipsMap[clip.id] = clip;
            });

            var selectionArray = getSelectionArray();
            for (var idx = 0; idx < selectionArray.length; idx++) {
                var clipId = selectionArray[idx].id;
                if (clipId in newClipsMap) {
                    selectionArray[idx] = angular.copy(newClipsMap[clipId]);
                } else {
                    selectionArray.splice(idx, 1);
                }
            }

            if (selectionArray.length < clipList.length) {
                self.selectAllFlag = false;
            }

            clipSelectionChanged();
        };

        var clearSelectedClips = function () {
            self.selectedClipArray = [];
            self.selectedDraftClipArray = [];
            clipSelectionChanged();
        };

        var setDataFromViewModel = function (viewModel) {
            updateSelectionArray(viewModel);

            self.perms = viewModel.perms;
            self.record = viewModel.record || {};
            self.clips = viewModel.clips;
            self.draftClips = viewModel.draftClips;
            self.totalDuration = viewModel.totalClipsDuration;
            self.clipInEdit = viewModel.clipInEdit;
            self.feedScheduleMap = viewModel.feedScheduleMap;
            self.availableFeeds = viewModel.availableFeeds;
            self.deliveryProgressMap = viewModel.deliveryProgressMap;
            if (!confirmingFeedSwitch) {
                self.currentFeed = viewModel.currentFeed;
            }
            self.showClipsLoading = viewModel.showClipsLoading;
        };

        var handleThumbnailUpload = function (thumbnailObject) {
            if (self.clipInEdit.id) {
                self.editorForm.$setDirty();
            }
            self.clipInEdit.clipThumbnailData = null;
            self.clipInEdit.clipImageOffset = null;
            self.clipInEdit.tempThumbnail = null;
            self.clipInEdit.imageTimeCode = null;
            self.clipInEdit.thumbnailObject = thumbnailObject;
        };

        self.setPlayerPropsFromRecord = function (record) {
            windowElement.on('streamStatus', handleStreamStatusEvent);
            self.props.sourcePath = defaultMediaPath + '/' + record.directory + '/stream/hls.m3u8';
            self.props.editMode = false;
            self.props.framerate = record.framerate;
            self.props.duration = calculateDuration();
            self.props.tracks = [];
            self.props.dropFrame = true;
            self.props.autoLevelCapping = 2;
        };

        var switchCurrentSchedule = function () {
            confirmingFeedSwitch = false;
            PackageLiveClipViewService.viewModel.currentFeed = self.currentFeed;
            if (self.currentFeed && self.currentFeed.isLive) {
                resumePlaybackAfterScheduleChange = $window.player.isPlaying();
                self.props.sourcePath = '';
                return PackageLiveClipViewService.switchCurrentSchedule().then(function (recordData) {
                    self.props.duration = calculateDuration();
                    if (!self.clipInEdit.id) {
                        self.props.markIn = null;
                        self.props.markOut = null;
                        self.clipInEdit = PackageLiveClipViewService.viewModel.clipInEdit = {};
                        self.setPlayerPropsFromRecord(recordData);
                        setLoading(false);
                    } else {
                        PackageUtilService.editorForm.$setDirty();
                        if (self.clipInEdit.clipImageOffset) {
                            createThumbnailAfterScheduleChange = true;
                        }
                        self.setPlayerPropsFromRecord(recordData);
                    }
                    return recordData;
                });
            } else if (self.packageObject.primaryVideo && self.packageObject.primaryVideo.proxyId) {
                self.props.sourcePath = '';
                if (self.clipInEdit.id) {
                    PackageUtilService.editorForm.$setDirty();
                }
                return setPlayerPropsFromPrimaryVideo();
            } else {
                return $q.when(true);
            }
        };

        var switchToClipFeed = function (clip) {
            self.streamExists = false;
            $window.liveClippingVideoPlayer.pause();
            if (clip.liveRecordId) {
                return PackageLiveClipViewService.switchToClipFeed(clip).then(function (record) {
                    self.setPlayerPropsFromRecord(record);
                });
            } else {
                self.currentFeed = self.availableFeeds.filter(function (feed) {
                    return !feed.isLive;
                })[0];
                return switchCurrentSchedule();
            }
        };

        var switchToClipFeedAndEditClip = function (clip) {
            clipToEdit = clip;
            return switchToClipFeed(clip);
        };

        windowElement.on('createClipEvent', function (e) {
            var clip = e.originalEvent.detail;
            if (self.draftClips.length) {
                self.showSelectDraftClipModal();
            } else if (self.currentFeed.isLive) {
                createLiveClip(clip);
            } else {
                self.createPreRecordedClip();
            }
        });

        windowElement.on('updateClipEvent', function (e) {
            var clip = e.originalEvent.detail;
            if (self.clipInEdit.packageData.revision > 1) {
                handleUpdateForDeliveredClip(clip);
            } else {
                updateClip();
            }
        });

        windowElement.on('timeUpdate', function (e) {
            self.currentPlayheadTime = e.originalEvent.detail.progress;
            if (clipPlaying && self.currentPlayheadTime >= clipPlaying.clipEndOffset) {
                $window.liveClippingVideoPlayer.pause();
                var clipEndOffset = clipPlaying.clipEndOffset;
                clipPlaying = null;
                $window.liveClippingVideoPlayer.seek(clipEndOffset);
            }
        });

        windowElement.on('markIn', function (e) {
            var newMarkIn = e.originalEvent.detail.markIn;
            var dropFrame = self.currentFeed.isLive;
            if (self.props.editMode && self.clipInEdit.clipStartOffset !== newMarkIn && !isNaN(newMarkIn)) {
                self.editorForm.$setDirty();
            }
            self.clipInEdit.clipStartOffset = newMarkIn;
            self.clipInEdit.markInTimeCode = timecodeFromSecFilter(self.clipInEdit.clipStartOffset, self.props.framerate, dropFrame);
            clipPlaying = null;
            if (self.clipInEdit.clipEndOffset) {
                self.clipInEdit.clipDuration = timecodeFromSecFilter(self.clipInEdit.clipEndOffset - self.clipInEdit.clipStartOffset, self.props.framerate, dropFrame);
            }

            _.defer(function () { $scope.$apply(); });
        });

        windowElement.on('markOut', function (e) {
            var newMarkOut = e.originalEvent.detail.markOut;
            var dropFrame = self.currentFeed.isLive;
            if (self.props.editMode && self.clipInEdit.clipEndOffset !== newMarkOut && !isNaN(newMarkOut)) {
                self.editorForm.$setDirty();
            }
            self.clipInEdit.clipEndOffset = newMarkOut;
            self.clipInEdit.markOutTimeCode = timecodeFromSecFilter(self.clipInEdit.clipEndOffset, self.props.framerate, dropFrame);
            clipPlaying = null;
            self.clipInEdit.clipDuration = timecodeFromSecFilter(self.clipInEdit.clipEndOffset - self.clipInEdit.clipStartOffset, self.props.framerate, dropFrame);

            _.defer(function () { $scope.$apply(); });
        });

        windowElement.on('createThumbnail', function (e) {
            if (e.originalEvent.detail.source === 'thumbnailBtn') {
                var offsetTime = self.currentPlayheadTime;
                var dropFrame = self.currentFeed.isLive;
                if (self.props.editMode && self.clipInEdit.clipImageOffset !== offsetTime) {
                    self.editorForm.$setDirty();
                }
                self.clipInEdit.tempThumbnail = e.originalEvent.detail.thumbnail;
                self.clipInEdit.clipImageOffset = offsetTime;
                self.clipInEdit.imageTimeCode = timecodeFromSecFilter(offsetTime, self.props.framerate, dropFrame);

                _.defer(function () { $scope.$apply(); });
            }
        });

        self.updateSchedules = function (recordMap) {
            setLoading(true);
            PackageLiveClipViewService.updateSchedule(recordMap).then(function () {
                setLoading(false);
            });
        };

        self.stopCancelRecord = function (event, record) {
            event.preventDefault();
            event.stopImmediatePropagation();
            setLoading(true);
            PackageLiveClipViewService.stopCancelRecord(record).then(function () {
                NotificationService.clearTimedNotifications();
                setLoading(false);
            });
        };

        self.getClipFeed = PackageLiveClipViewService.getClipFeed;

        self.editClip = function (clip) {
            PackageUtilService.tabLoadDataFunction = function () {
                getEditClipData(clip);
            };

            selectClipInEdit(clip);

            $location.search('livePackageId', clip.id);
            setLoading(true);
            if (!self.draftClipMode && clip.liveRecordId && self.record.id !== parseInt(clip.liveRecordId)) {
                switchToClipFeedAndEditClip(clip);
            } else if (!self.draftClipMode && !clip.liveRecordId && self.currentFeed && self.currentFeed.isLive) {
                switchToClipFeedAndEditClip(clip);
                getEditClipData(clip);
            } else {
                getEditClipData(clip);
            }
        };

        self.onCloseClipEdit = function () {
            if (self.metadataForm.$dirty || self.collaboratorsForm.$dirty || self.distributionForm.$dirty ||
                self.advancedForm.$dirty || PackageUtilService.editorForm.$dirty) {
                var message = 'You have unsaved changes.  Please save or revert.';
                NotificationService.createWarningNotification(message, '');
            } else {
                setLoading(true);
                self.exitEditClipMode();
            }
        };

        self.exitEditClipMode = function () {
            clearSelectedClips();
            $location.search('livePackageId', null);

            return PackageLiveClipViewService.exitEditClipMode().then(function () {
                self.props.editMode = false;
                self.props.markIn = NaN;
                self.props.markOut = NaN;
                clipPlaying = null;
                setLoading(false);
                PackageUtilService.tabLoadDataFunction = PackageLiveClipViewService.refreshClips;
            });
        };

        self.acceptClip = function (clip) {
            function acceptWithDelivery(skipNotification) {
                setLoading(true);
                PackageLiveClipViewService.acceptClip(clip, true).then(function () {
                    setLoading(false);
                    if (skipNotification === true) {
                        return;
                    }
                    NotificationService.createSuccessNotification(
                        'Clip media will be ingested and delivered.', 2000);
                });
            }

            function acceptWithoutDelivery() {
                setLoading(true);
                PackageLiveClipViewService.acceptClip(clip, false).then(function () {
                    setLoading(false);
                    NotificationService.createSuccessNotification(
                        'Clip media will be recaptured but NOT delivered.', 2000);
                });
            }

            if (clip.autoDeliver) {
                // A new clip was accepted
                acceptWithDelivery(true);
            } else {
                // An already-delivered clip was accepted
                ModalService.showMessageModal({
                    messageText: 'Clip media will be recaptured.\n' +
                    'Would you like to deliver the clip?',
                    title: 'Confirm Clip Redelivery',
                    windowClass: 'confirm-modal-sm',
                    showOK: true,
                    okText: 'Yes',
                    cancelText: 'No',
                    pullCancelLeft: false
                }, acceptWithDelivery, acceptWithoutDelivery);
            }
        };

        self.formattedStatus = function () {
            return self.record.status.charAt(0).toUpperCase() + self.record.status.slice(1);
        };

        self.getAssetURL = function (clip) {
            if (clip.tempThumbnail) {
                return clip.tempThumbnail;
            } else if (clip.thumbnailObject && clip.thumbnailObject.data) {
                return clip.thumbnailObject.data;
            } else if (clip.liveClipTempThumbnailPath) {
                return proxyUrl + '/' + clip.liveClipTempThumbnailPath;
            } else if (clip.primaryImage && clip.primaryImage.proxyPath) {
                return proxyUrl + '/' + clip.primaryImage.proxyPath;
            } else if (clip.clipThumbnailData) {
                return clip.clipThumbnailData;
            } else {
                return 'assets/images/no-proxy-16x9.png';
            }
        };

        self.activateEditTab = function (editTab) {
            resetActive();
            self.activeEditTabs[editTab] = true;
        };

        self.collaboratorDeleteInvalid = function () {
            return PackageUtilService.tabDeleteInvalid();
        };

        self.statusAllowsEdit = function (clip) {
            return PackageUtilService.statusAllowsEdit(clip.status);
        };

        self.showClipEditButton = function (clip) {
            var userCanEdit = PermissionsService.isAdmin() || ((clip.lockedBy) ? self.perms.userId === clip.lockedBy.id : true);
            return PackageUtilService.statusAllowsEdit(clip.status) && userCanEdit;
        };

        self.disableClipAccept = function (clip) {
            return self.clipHasErrors(clip) || !!clip.lockedBy || (!clip.clipImageOffset && !clip.primaryImage) || clip.hidden;
        };

        self.showScheduleModal = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!self.scheduleButtonDisabled()) {
                PackageUtilService.showClipScheduler();
            }
        };

        self.scheduleButtonDisabled = function () {
            return !PermissionsService.isAdmin();
        };

        $scope.$watch(function () {
            return self.editorForm;
        }, function (newValue) {
            if (newValue) {
                PackageUtilService.editorForm = self.editorForm;
            }
        });

        $scope.$watchCollection(function () {
                return [self.metadataForm, self.collaboratorsForm, self.distributionForm, self.advancedForm];
            },
            function (newValue) {
                if (PackageLiveClipViewService.metadataForm !== newValue[0]) {
                    PackageLiveClipViewService.metadataForm = newValue[0];
                }
                if (PackageLiveClipViewService.collaboratorsForm !== newValue[1]) {
                    PackageLiveClipViewService.collaboratorsForm = newValue[1];
                }
                if (PackageLiveClipViewService.distributionForm !== newValue[2]) {
                    PackageLiveClipViewService.distributionForm = newValue[2];
                }
                if (PackageLiveClipViewService.advancedForm !== newValue[3]) {
                    PackageLiveClipViewService.advancedForm = newValue[3];
                }
                if (((self.metadataForm && self.metadataForm.$dirty) ||
                        (self.collaboratorsForm && self.collaboratorsForm.$dirty) ||
                        (self.distributionForm && self.distributionForm.$dirty) ||
                        (self.advancedForm && self.advancedForm.$dirty)) && PackageUtilService.editorForm) {
                    PackageUtilService.editorForm.$setDirty();
                } else if (PackageUtilService.editorForm) {
                    PackageUtilService.editorForm.$setPristine();
                }
            }, true);

        $scope.$on('$destroy', function () {
            if (self.clipInEdit && self.clipInEdit.id) {
                self.exitEditClipMode();
            }
            $location.search('livePackageId', null);
            windowElement.off('createClipEvent');
            windowElement.off('updateClipEvent');
            windowElement.off('timeUpdate');
            windowElement.off('markIn');
            windowElement.off('markOut');
            windowElement.off('createThumbnail');
            windowElement.off('streamStatus');
            $window.player.off('play');
            $window.player.off('pause');
            PackageLiveClipViewService.cleanup();
            self.props = null;
            PackageUtilService.postCloseUpdate = null;
        });

        self.checkSave = function () {
            if (self.clipInEdit.packageData.revision > 1) {
                var clipData = {
                    markIn: self.clipInEdit.clipStartOffset,
                    markOut: self.clipInEdit.clipEndOffset
                };
                handleUpdateForDeliveredClip(clipData);
            } else {
                self.onSave();
            }
        };

        // Clip package edit
        self.onSave = function () {
            setLoading(true);
            PackageLiveClipViewService.onSave({}, false, false).then(function (saveData) {
                self.exitEditClipMode();
            });
        };

        self.onRevert = function () {
            var deferred = $q.defer();

            if ((self.clipInEdit.liveRecordId && self.record.id !== parseInt(self.clipInEdit.liveRecordId)) ||
                (!self.clipInEdit.liveRecordId && self.currentFeed.isLive)) {
                switchToClipFeedAndEditClip(self.clipInEdit.packageData).then(function () {
                    deferred.resolve(true);
                });
            } else {
                deferred.resolve(true);
            }

            deferred.promise.then(function () {
                PackageLiveClipViewService.revertData();
                getEditClipData(self.clipInEdit).then(function () {
                    self.goToIn();
                });
            });
        };

        self.toolBarDisabled = function () {
            if (!self.metadataForm || !self.collaboratorsForm || !self.distributionForm || !self.advancedForm) {
                return true;
            }
            return self.metadataForm.$pristine &&
                self.collaboratorsForm.$pristine &&
                self.distributionForm.$pristine &&
                self.advancedForm.$pristine &&
                PackageUtilService.editorForm.$pristine;
        };

        self.disableTab = function (tabName) {
            return !self.activeEditTabs[tabName] && PackageUtilService.editorForm && !PackageUtilService.editorForm.$pristine;
        };

        self.clipHasErrorsWarnings = function (clip) {
            for (var i = 0; clip.validationResult && i < clip.validationResult.length; i++) {
                if ((clip.validationResult[i].errors && clip.validationResult[i].errors.length) || (clip.validationResult[i].warnings && clip.validationResult[i].warnings.length)) {
                    return true;
                }
            }
            return false;
        };

        self.clipHasErrors = function (clip) {
            for (var i = 0; i < clip.validationResult.length; i++) {
                if (clip.validationResult[i].errors && clip.validationResult[i].errors.length) {
                    return true;
                }
            }
            return false;
        };

        self.showErrorsAndWarningsForClip = function (clip) {
            ModalService.showErrorsWarningsModal(clip.validationResult, clip.title);
        };

        PackageUtilService.showClipScheduler = function () {
            ModalService.showLiveClipScheduleModal(self.packageObject, PackageLiveClipViewService.viewModel.currentFeed, self.availableFeeds, self.stopCancelRecord, self.updateSchedules);
        };

        self.createNewClip = function (newClip, isDraftClip) {
            setLoading(true);
            clearSelectedClips();

            PackageLiveClipViewService.createNewClip(newClip, isDraftClip).then(function () {
                var notificationMessage;

                if (newClip.numberOfClips > 1) {
                    notificationMessage = ' Clips \'' + newClip.title + '\' were succesfully created.';
                } else {
                    notificationMessage = 'Clip \'' + newClip.title + '\' was succesfully created.';
                }

                setLoading(false);
                NotificationService.createSuccessNotification(notificationMessage, 2000);
            });
        };

        self.createPreRecordedClip = function () {
            self.createNewClip({
                name: PackageLiveClipViewService.createInitialClipName()
            }, false);
        };

        self.showCreateDraftClipModal = function () {
            ModalService.showCreateClipModal(function (draftClip) {
                self.createNewClip(draftClip, true);
            });
        };

        self.handleDraftClipCancel = function () {
            self.props.markIn = self.clipInEdit.clipStartOffset;
            self.props.markOut = self.clipInEdit.clipEndOffset;
        };

        self.assignMarkPointsToDraftClip = function (draftClip) {
            setLoading(true);
            PackageLiveClipViewService.assignMarkPointsToDraftClip(draftClip).then(function () {
                self.exitEditClipMode();
                setLoading(false);
            });
        };

        self.showSelectDraftClipModal = function () {
            self.props.markIn = null;
            self.props.markOut = null;
            ModalService.showSelectDraftClipModal(self.draftClips, self.assignMarkPointsToDraftClip, self.handleDraftClipCancel);
        };

        self.removeDraftClip = function (draftClip) {
            function confirmResult() {
                setLoading(true);
                PackageLiveClipViewService.removeDraftClip(draftClip).then(function () {
                    setLoading(false);
                });
            }

            ModalService.showMessageModal({
                messageText: 'Are you sure you want to remove draft clip ' + draftClip.title + '?',
                pullCancelLeft: true,
                title: 'Remove Draft Clip',
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, confirmResult);
        };

        self.goToIn = function (event) {
            if (event) {
                event.currentTarget.blur();
            }
            $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipStartOffset);
        };

        self.goToImage = function (event) {
            event.currentTarget.blur();
            $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipImageOffset);
        };

        self.goToOut = function (event) {
            event.currentTarget.blur();
            $window.liveClippingVideoPlayer.seek(self.clipInEdit.clipEndOffset);
        };

        self.playClip = function (event, clip) {
            if (event) {
                event.currentTarget.blur();
            }
            if (!clip) {
                clip = self.clipInEdit;
            }
            $window.liveClippingVideoPlayer.seek(clip.clipStartOffset);
            $window.liveClippingVideoPlayer.play();
            clipPlaying = clip;
        };

        self.onMarkInChange = function () {
            var dropFrame = self.currentFeed.isLive;
            self.props.markIn = secFromTimecodeFilter(self.clipInEdit.markInTimeCode, self.props.framerate, dropFrame);
            self.props.markOut = null;
        };

        self.onMarkOutChange = function () {
            var dropFrame = self.currentFeed.isLive;
            var updateMarkOut = secFromTimecodeFilter(self.clipInEdit.markOutTimeCode, self.props.framerate, dropFrame);
            if (updateMarkOut > 0) {
                self.props.markOut = updateMarkOut;
                self.props.markIn = null;
                $window.liveClippingVideoPlayer.seek(updateMarkOut);
            }
        };

        self.searchClips = function (clip) {
            if (!self.clipSearch.text) {
                return self.clipSearch.includeDelivered || clip.status !== 'DELIVERED';
            }
            return ((clip.title && clip.title.toLowerCase().indexOf(self.clipSearch.text.toLowerCase()) !== -1) ||
                (clip.name && clip.name.toLowerCase().indexOf(self.clipSearch.text.toLowerCase()) !== -1)) &&
                (self.clipSearch.includeDelivered || clip.status !== 'DELIVERED');
        };

        self.addAdHocSubscription = function () {
            PackageUtilService.tabAdHocPartnerFunction();
        };

        self.clipCollaboratorsChanged = function () {
            self.collaboratorsForm.$setDirty();
        };

        var markPointsSet = function () {
            return !self.clipInEdit.id && (self.clipInEdit.markInTimeCode || self.clipInEdit.markOutTimeCode || self.clipInEdit.imageTimeCode);
        };

        self.selectScheduleForFeed = function () {
            function revertFeedSwitch() {
                confirmingFeedSwitch = false;
                self.currentFeed = PackageLiveClipViewService.viewModel.currentFeed;
            }

            function confirmFeedSwitch() {
                switchCurrentSchedule().then(function () {
                    setLoading(false);
                });
            }

            if (markPointsSet()) {
                confirmingFeedSwitch = true;
                ModalService.showMessageModal({
                    messageText: 'Are you sure you want to switch feeds?\nWARNING - The current mark-in/mark-out and image timecodes will be reset.',
                    title: 'Confirm Switch Feed',
                    windowClass: 'confirm-modal-sm',
                    showOK: true,
                    pullCancelLeft: true
                }, confirmFeedSwitch, revertFeedSwitch);
            } else {
                setLoading(true);
                confirmFeedSwitch();
            }
        };

        self.unlockClip = PackageLiveClipViewService.unlockClip;

        self.preventClickInDraftMode = function (event) {
            if ((self.draftClipMode && self.clipInEdit.id) || !self.streamExists) {
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
            }
        };

        self.isClipSelected = function (clip) {
            return getSelectionIndex(clip) >= 0;
        };

        self.toggleDraftClipMode = function () {
            self.selectedClipArray = [];
            self.selectedDraftClipArray = [];
            self.selectAllFlag = false;
            self.draftClipMode = !self.draftClipMode;
            self.props.enableKeyboardShortcuts = !self.draftClipMode;
        };

        self.selectClipCheckboxClicked = function (clip, event) {
            if (!self.draftClipMode) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
            var idx = getSelectionIndex(clip);
            if (idx < 0) {
                getSelectionArray().push(angular.copy(clip));
            } else {
                getSelectionArray().splice(idx, 1);
            }

            self.selectAllFlag = false;
            clipSelectionChanged();
        };

        self.selectAllClicked = function () {
            var clipList = getClipList();
            getSelectionArray().splice(0, getSelectionArray().length);
            if (self.selectAllFlag) {
                angular.forEach(clipList, function (clip) {
                    getSelectionArray().push(clip);
                });
            }
            clipSelectionChanged();
        };

        self.openCompletedDeliveriesModal = function (clip) {
            // setLoading(true);
            ModalService.showCompletedDeliveriesModal(clip);
        };

        self.showNoImageErrorIcon = function () {
            return !!self.clipInEdit.id && self.getAssetURL(self.clipInEdit) === 'assets/images/no-proxy-16x9.png';
        };

        self.openFileUploadModal = function () {
            var imageUploadAcceptTemplate = {acceptProfile: {fileExtensions: ['png', 'PNG'], height: '', width: ''}};
            // Live Feeds always require a 1280x720 thumbnail, for non-live we'll use the Main Video dimensions
            if (self.currentFeed.isLive) {
                imageUploadAcceptTemplate.acceptProfile.height = '720';
                imageUploadAcceptTemplate.acceptProfile.width = '1280';
            } else {
                imageUploadAcceptTemplate.acceptProfile.height = self.currentFeed.height;
                imageUploadAcceptTemplate.acceptProfile.width = self.currentFeed.width;
            }
            ModalService.showFileUploadModal([imageUploadAcceptTemplate], 'image', handleThumbnailUpload);
        };

        self.canDownloadProxy = function () {
            return !!self.packageObject && !!self.packageObject.primaryVideo && !!self.packageObject.primaryVideo.proxyId &&
                !!self.currentFeed && !self.currentFeed.isLive && !!self.perms && !!self.perms.downloadProxy &&
                PermissionsService.hasReadWritePermission(parseInt(self.perms.downloadProxy.permission));
        };

        self.downloadMainProxy = function () {
            let proxyFileName = PackageMediaService.generatePackageDownloadFilenamePrefix(self.packageObject, false) +
                'video_proxy.' + UtilsService.getFileExtension(self.packageObject.primaryVideo.proxyPath);
            DownloadAssetService.downloadAsset(self.packageObject.primaryVideo.proxyId, proxyFileName, DownloadAssetService.AssetType.Video, DownloadAssetService.ContentUse.Proxy);
        };

        var onPlayerLoadedAndReady = function (handler) {
            //
            // TODO
            // 		This works great, but is certainly not clean or elegant.
            //		It's also challenging to unit test properly.
            //
            $window.player.on('ready', function () {
                $window.player.off('ready');
                angular.element('video').on('canplay', function () {
                    angular.element('video').off('canplay');
                    handler();
                });
            });
        };

        self.clipThumbClicked = function (clip) {
            if (clip.primaryVideo) {
                ModalService.showMediaModal('clip', clip.primaryVideo, clip.id);
            } else {
                var clipFeed = PackageLiveClipViewService.getClipFeed(clip);
                if (self.currentFeed !== clipFeed) {
                    setLoading(true);
                    self.currentFeed = clipFeed;
                    onPlayerLoadedAndReady(function () {
                        self.playClip(undefined, clip);
                    });
                    switchToClipFeed(clip, true).then(function () {
                        setLoading(false);
                    });
                } else {
                    self.playClip(undefined, clip);
                }
            }
        };

        var isOffsetValid = function (offset) {
            return offset !== undefined && offset !== null && !isNaN(offset);
        };

        self.hasMarkIn = function () {
            return isOffsetValid(self.clipInEdit.clipStartOffset);
        };

        self.hasMarkOut = function () {
            return isOffsetValid(self.clipInEdit.clipEndOffset);
        };

        self.hasMarkPoints = function () {
            return self.hasMarkIn() && self.hasMarkOut();
        };

        $scope.$watch(function () {
            return PackageLiveClipViewService.viewModel;
        }, function (viewModel) {
            setDataFromViewModel(viewModel);
        }, true);

        self.getEditData = function () {
            setLoading(true);
            setDataFromViewModel(PackageLiveClipViewService.viewModel);
            var deepLinkClipToEdit = ($location.search().livePackageId) ? PackageResourceFactory.get({id: $location.search().livePackageId}).$promise : $q.resolve(null);

            deepLinkClipToEdit.then(function (clip) {
                $q.all({
                    perms: PackageLiveClipViewService.getPermissions(clip),
                    editData: PackageLiveClipViewService.getEditData()
                }).then(function (allData) {
                    if (clip) {
                        selectClipInEdit(clip);
                        switchToClipFeedAndEditClip(clip).then(function () {
                            if (!self.currentFeed) {
                                getEditClipData(clipToEdit);
                            }
                            setLoading(false);
                        });
                    } else if (self.packageObject.primaryVideo && self.packageObject.primaryVideo.proxyId) {
                        setPlayerPropsFromPrimaryVideo().then(function () {
                            setLoading(false);
                        });
                    } else if (allData.editData && allData.editData.record && allData.editData.record.id) {
                        self.setPlayerPropsFromRecord(allData.editData.record);
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                    PackageActionService.selectedPackages = getSelectionArray();
                });
            });
        };

        PackageUtilService.tabLoadDataFunction = PackageLiveClipViewService.refreshClips;
        self.getEditData();
    });
